import {
  Component,
  OnInit,
  Inject,
  LOCALE_ID,
  PLATFORM_ID
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { ProductsMange } from "./productsManange";
import { tap } from "rxjs/operators";
import { IPagination } from "./pagination/Ipagination";
import { Title, Meta } from "@angular/platform-browser";
import { LinkService } from "../../service/link.service";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-shop",
  templateUrl: "./shop.component.html",
  styleUrls: ["./shop.component.scss"]
})
export class AllProducts extends ProductsMange implements OnInit {
  p = 1;
  pagination: IPagination;
  title: string;
  description: string;
  image: string;
  url: string;
  isBrowser: boolean;
  currentLangId: string;

  constructor(
    public _facadeService: FacadeService,
    @Inject(LOCALE_ID) public locale,
    @Inject(PLATFORM_ID) public platformId,
    public titleService: Title,
    public metaService: Meta,
    public link: LinkService
  ) {
    super(_facadeService);
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    }
    this.currentLangId = this.locale;
  }

  ngOnInit() {
    this.setSeoTagsProperties();
    this.getProducts();
    this.getAllCatogeries();
  }

  getProducts() {
    this.products = [];
    this._facadeService.Product.getProducts({
      page: this.p
    }).subscribe(res => {
      this.setProductRespone(res);
      this.pagination = {
        currentPage: res.data.current_page,
        lastPage: res.data.last_page
      };
    });
  }

  onLoad(index: number) {
    this.loaded(index);
  }

  pageChanged(page) {
    // Change the current page
    this.pagination.currentPage = page;
    this.p = page;

    // Scroll to top
    window.scroll(0, 0);

    // Get the new page data
    this.getProducts();
  }

  setSeoTagsProperties() {
    const currentUrlLang = this.currentLangId === "en" ? "" : "ar/";
    if (this.currentLangId === "ar") {
      this.title = "نيو فرنتشر للاثاث المكتبي | افضل الخامات و اقل الاسعار ";
      this.description =
        "نيو فرنتشر لبيع جميع انواع الاثاث المكتبي . كاونتر, مكاتب مديرين, طاولة اجتماعات, خلية عمل, اطقم انتريه, كراسي ";
    } else {
      this.title = "New furniture Egypt | the best quality with least prices ";
      this.description =
        "We are specialist of the fine products of all kind of office furniture. counters, workstations, meeting tables, manager desks";
    }
    this.url =
      "https://www.newfurniture-eg.com/" + currentUrlLang + "products/";
    this.link.addTag({
      rel: "",
      href: this.url
    });

    this.setSeoTags(this.title, this.description, this.image, this.url);
  }

  setSeoTags(Title, description, img, url, currentPage?): void {
    this.removeCurrentTags();
    if (!img) {
      img = "https://www.newfurniture-eg.com/assets/logo.png";
    }
    this.titleService.setTitle(Title);
    this.metaService.addTags([
      {
        name: "description",
        content: description
      },
      {
        itemprop: "description",
        name: "og:description",
        content: description
      },
      {
        itemprop: "description",
        content: description
      },
      {
        name: "twitter:description",
        content: description
      },
      {
        name: "og:title",
        content: Title
      },
      {
        name: "og:type",
        content: "article"
      },
      {
        name: "og:url",
        content: url
      },
      {
        name: "og:image",
        content: img
      },
      {
        name: "twitter:card",
        content: "summary"
      },
      {
        name: "twitter:title",
        content: Title
      },
      {
        name: "twitter:image",
        content: img
      },
      {
        itemprop: "name",
        content: Title
      },
      {
        itemprop: "image",
        content: img
      }
    ]);

    this.addLinkTagtoPage(currentPage, url);
  }

  addLinkTagtoPage(currentPage, url): void {
    const alternativeLng = this.currentLangId === "en" ? ".com/ar/" : ".com/",
      altLang = this.currentLangId === "ar" ? "en" : "ar";

    const locle = this.currentLangId == "en" ? "en_US" : "ar_AR",
      alte = this.currentLangId != "en" ? "en_US" : "ar_AR";
    this.link.removeTag('rel="canonical"');
    this.link.removeTag('rel="alternate"');

    this.link.addTag({
      rel: "canonical",
      href: url,
      hreflang: this.currentLangId + "-eg"
    });
    this.link.addTag({
      rel: "alternate",
      href:
        this.currentLangId === "en"
          ? url.replace(`.com/`, `${alternativeLng}`)
          : url.replace(`.com/ar/`, `${alternativeLng}`),
      hreflang: altLang + "-eg"
    });

    this.metaService.addTag({
      property: "og:locale",
      content: `${locle}`
    });
    this.metaService.addTag({
      property: "og:locale:alternate",
      content: `${alte}`
    });
  }

  removeCurrentTags(): void {
    if (this.isBrowser) {
      this.metaService.removeTag(" name ='twitter:description'");
      this.metaService.removeTag(" name ='og:description'");
      this.metaService.removeTag(" name ='description'");
      this.metaService.removeTag("itemprop='description'");
      this.metaService.removeTag(" name = 'og:title' ");
      this.metaService.removeTag(" name ='og:url'");
      this.metaService.removeTag(" name ='og:image'");
      this.metaService.removeTag(" name ='og:locale:alternate'");
      this.metaService.removeTag(" name ='og:locale:alternate'");

      this.metaService.removeTag(" name ='twitter:title'");
      this.metaService.removeTag(" name ='twitter:image'");
      this.metaService.removeTag(" itemprop ='name'");
      this.metaService.removeTag(" itemprop ='image'");
    }
  }
}
